import React from "react";
import { QualificationForm } from "./Forms/QualificationForm";
import { useCreateQualificationMutation } from "../../services/basicData/basicData";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { PageHeader } from "../../CommonElements/PageTitle";
import { Container, Form, Spinner } from "reactstrap";
import { Stack } from "react-bootstrap";

export const CreateQualification = () => {
  const {
    handleSubmit,
    control,
    formState: { errors },
    setError,
  } = useForm({
    defaultValues: {
      name_ar: "",
      name_en: "",
    },
  });

  const { mutate: createQualification, isPending } = useCreateQualificationMutation(setError);
  const { t } = useTranslation();

  const onSubmit = (data) => {
    createQualification(data);
  };

  return (
    <Stack gap={2}>
      <PageHeader title={t("CREATE_QUALIFICATION")}  />
      <Container fluid>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <QualificationForm control={control} errors={errors} />
          <Button variant="primary" type="submit" disabled={isPending}>
            {isPending ? (
              <>
                <Spinner size="sm" />
                {t("CREATING_QUALIFICATION")}
              </>
            ) : (
              t("CREATE_QUALIFICATION")
            )}
          </Button>
        </Form>
      </Container>
    </Stack>
  );
};
